import { useMemo } from "react"
import { Gallery } from "src/components/product-details/Gallery"
import { SlideImageData } from "src/data/product-details/types"
import { useProductContext } from "./context"

export type DimensionsProps = {
  dimensionImages: string[]
}

export const ProductDimensions = () => {
  const { dimensions } = useProductContext()

  const dimensionImages = useMemo(() => {
    return dimensions?.flatMap<SlideImageData>((dimension) => {
      if (!dimension?.image) {
        return []
      }

      return {
        src: dimension.image,
        alt: dimension.name,
        captionPrimary: dimension.name,
        captionSecondary: dimension.value,
      }
    })
  }, [dimensions])

  if (!dimensionImages?.length) {
    return null
  }

  return <Gallery heading="Abmessungen" slides={dimensionImages} />
}
